'use strict';

angular.module('app')
  .factory('Profile', function ($rootScope, Request, gettextCatalog, Auth) {
    var Profile = {};


    Profile.getPersonalInfo = function () {
      return Request.get('account/personal-info/').then(function (res) {
        return res.data;
      });
    };

    Profile.setPersonalInfo = function (data, form) {
      form.$submitted = true;

      if (form.$invalid) {
        return true;
      }

      if (data.contactInformation && _.isEmpty(data.contactInformation.dob)) {
        data.contactInformation.dob = null;
      }

      return Request.patch('account/personal-info/', data).then(function (res) {
        if (res.data.firstName.length > 0) {
          $rootScope.user.firstName = res.data.firstName;
          Auth.saveUser($rootScope.user);
        }
        $rootScope.showNotify(gettextCatalog.getString('Your personal information was successfully changed'));

        return res.data;
      });
    };


    Profile.getContactInfo = function () {
      return Request.get('account/contact-info/').then(function (res) {
        return res.data;
      });
    };

    Profile.setContactInfo = function (data, form) {
      form.$submitted = true;

      if (form.$invalid) {
        return true;
      }

      return Request.patch('account/contact-info/', data).then(function (res) {
        $rootScope.showNotify(gettextCatalog.getString('Your contact information was successfully changed'));

        return res.data;
      });
    };

    Profile.getPhone = function () {
      return Request.get('account/contact-phone/').then(function (res) {
        return res.data;
      });
    };

    Profile.setPhone = function (data, form) {
      form.$submitted = true;

      if (form.$invalid) {
        return true;
      }

      return Request.patch('account/contact-phone/', data).then(function (res) {
        $rootScope.showNotify(gettextCatalog.getString('Your phone number was successfully changed'));
        return res.data;
      });
    };

    return Profile;
  });
